import React, { Component } from "react";
import api from "../../services/api";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";



import Moment from 'moment';
import 'moment/locale/pt';
import './styles.css';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';

import { Link } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class UsersUnidadesVip extends Component {


    state = {
      users: [],
      usersInfo: {},
      open: true,
      };
    
      async componentDidMount(){   
        this.loadUsersVIP();  
      };

      loadUsersVIP = async (page = 1) => {
        const { id } = this.props.match.params;  
        const response = await api.get(`/api/users_select/2?page=${page}`);  
        const { ...usersInfo } = response.data;
        this.setState({
          users: response.data,
          usersInfo,
           page  
        });
      };
    

    render() {
        const { open, users, page , usersInfo} = this.state;   
        return (
      
          <Dialog fullScreen open={open} TransitionComponent={Transition}>
          <AppBar className="appBar" style={{backgroundColor:"#666"}}>
            <Toolbar>
              
              <table style={{width:"100%"}}>
                <tr>
                  <td align="left"><Typography variant="h6" className="title" style={{textTransform:"none"}}>
                    &nbsp; Usuários VIP / ({users.length})&nbsp;&nbsp;&nbsp;



                  </Typography>
                 
              </td>
                  <td align="right">
                    <Link to={`/admin/usuarios`}>
                  <IconButton edge="start" style={{color:'#fff'}} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                  </Link>
              </td>
                </tr>
              </table>
                   
            </Toolbar>
          </AppBar>
      <br />&nbsp;
          <GridContainer style={{padding:30,}}>  

           <GridItem xs={12} sm={12} md={12}>
                      <div align="right" style={{marginBottom:20, marginTop:20,}}>
                      <Link style={{
                      backgroundColor:"#666",   
                      height: 42,
                      borderRadius: 5,
                      color: '#fff',
                      fontSize: 14,
                      textDecoration: 'none',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 10,
                      paddingLeft: 30,
                      paddingRight: 35,
                      fontWeight:400
                      }} to={`/adduservip/2`}>+ Criar usuário</Link>
                    </div>
                  </GridItem>


          {users.map(users => (
        <GridItem xs={12} sm={12} md={3} key={users._id}>
        <div className="doadores-list">
            <article >
            
              <p style={{fontSize:14, color:"#333"}}>
                Criado em <strong>{Moment(users.createdAt).format('L')}</strong>
              </p>

             
         
              <strong style={{color:"#666", fontWeight:600}}>
              {users.nome}
              </strong>
       
  
              <p style={{fontSize:14,}}>
              {users.email}
              </p>
  
             
         
              <Link style={{borderColor:"#666", backgroundColor:"#666", color:"#FFF", fontSize:14, fontWeight:400}} to={`/edituser/${users._id}`}>Alterar</Link>
         
          
            </article>
            </div>          
                
           </GridItem>
           
             ))} 


         
         </GridContainer>   
         

        

        </Dialog>
          
       
        );
    }
}